import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useLanguage } from "../i18n/LanguageContext";
import "./AppShell.css";

const NAV_ITEMS = [
  { to: "/app/snippets", key: "snippets" },
  { to: "/app/dotphrases", key: "dotphrases" },
  { to: "/app/websites", key: "websites" },
  { to: "/app/library", key: "library" },
  { to: "/app/try", key: "playground" },
  { to: "/app/profile", key: "profile" },
];

export const AppShell = ({ title, description, action, children }) => {
  const { user, signOut } = useAuth();
  const { portal } = useLanguage();

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-inner">
          <div className="app-header-top">
            <Link to="/" className="app-brand">
              FastLex
            </Link>
            <div className="app-header-meta">
              <span className="app-user">{user?.email}</span>
              <button type="button" className="app-signout" onClick={signOut}>
                {portal.common.signOut}
              </button>
            </div>
          </div>
          <nav className="app-nav" aria-label={portal.common.appSections}>
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive ? "app-nav-link active" : "app-nav-link"
                }
              >
                {portal.nav[item.key]}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="app-main">
        {(title || description || action) && (
          <div className="app-intro">
            <div className="app-intro-copy">
              {title && <h1>{title}</h1>}
              {description && <p>{description}</p>}
            </div>
            {action && <div className="app-intro-action">{action}</div>}
          </div>
        )}
        {children}
      </main>
    </div>
  );
};
